import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
const Kontak = () => {
    const { t } = useTranslation();

    const [formValues, setFormValues] = useState({
        nama: '',
        email: '',
        phone: '',
        subjek: '',
        inputText: ''
    });

    const [fieldErrors, setFieldErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    // Fungsi untuk sanitasi input - mencegah XSS dan injection
    const sanitizeInput = (input) => {
        if (typeof input !== 'string') return input;

        return input
            .replace(/[<>]/g, '') // Hapus tag HTML
            .replace(/['"]/g, '') // Hapus quotes yang bisa digunakan untuk injection
            .replace(/javascript:/gi, '') // Hapus javascript protocol
            .replace(/on\w+=/gi, ''); // Hapus event handlers
    };

    // Validasi yang lebih ketat
    const validateField = (name, value) => {
        // Sanitasi input terlebih dahulu
        const sanitizedValue = sanitizeInput(value);

        switch (name) {
            case "nama":
                if (sanitizedValue.trim() === '') return "*Wajib diisi";
                if (sanitizedValue.length < 2) return "*Nama minimal 2 karakter";
                // if (sanitizedValue.length > 50) return "*Nama maksimal 50 karakter";
                if (!/^[a-zA-Z\s]+$/.test(sanitizedValue)) return "*Nama hanya boleh huruf";
                return null;

            case "subjek":
                if (sanitizedValue.trim() === '') return "*Wajib diisi";
                if (sanitizedValue.length < 3) return "*Subjek minimal 3 karakter";
                // if (sanitizedValue.length > 100) return "*Subjek maksimal 100 karakter";
                return null;

            case "inputText":
                if (sanitizedValue.trim() === '') return "*Wajib diisi";
                if (sanitizedValue.length < 10) return "*Pesan minimal 10 karakter";
                // if (sanitizedValue.length > 1000) return "*Pesan maksimal 1000 karakter";
                return null;

            case "email":
                if (sanitizedValue.trim() === '') return "*Wajib diisi";
                if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(sanitizedValue)) return "*Email tidak valid";
                if (sanitizedValue.length > 100) return "*Email terlalu panjang";
                return null;

            case "phone":
                if (sanitizedValue.trim() === '') return "*Wajib diisi";
                if (!/^[0-9+\-\s()]{10,15}$/.test(sanitizedValue)) return "*Nomor telepon tidak valid";
                return null;

            default:
                return null;
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // Sanitasi input sebelum menyimpan ke state
        const sanitizedValue = sanitizeInput(value);
        setFormValues({ ...formValues, [name]: sanitizedValue });

        setFieldErrors({ ...fieldErrors, [name]: validateField(name, sanitizedValue) });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const newFieldErrors = {};
        Object.keys(formValues).forEach((key) => {
            newFieldErrors[key] = validateField(key, formValues[key]);
        });

        setFieldErrors(newFieldErrors);

        const allValid = Object.values(newFieldErrors).every(error => error === null);
        if (allValid) {
            setIsLoading(true);

            // Sanitasi final sebelum mengirim ke server
            const sanitizedData = {
                name: sanitizeInput(formValues.nama),
                email: sanitizeInput(formValues.email).toLowerCase(),
                phone_number: sanitizeInput(formValues.phone).replace(/[^\d+\-\s()]/g, ''), // Hanya angka dan karakter telepon yang valid
                subjek: sanitizeInput(formValues.subjek),
                pesan: sanitizeInput(formValues.inputText)
            };

            // Validasi ulang data yang sudah disanitasi
            const finalValidation = Object.keys(sanitizedData).every(key => {
                if (key === 'phone_number') {
                    return validateField('phone', sanitizedData[key]) === null;
                }
                return validateField(key === 'name' ? 'nama' : key === 'pesan' ? 'inputText' : key, sanitizedData[key]) === null;
            });

            if (!finalValidation) {
                setIsLoading(false);
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "Data tidak valid. Silakan periksa kembali input Anda."
                });
                return;
            }

            const url = process.env.REACT_APP_API_URL;
            const endpoint = process.env.REACT_APP_API_INPUT_KONTAK;

            // Validasi URL endpoint
            if (!url || !endpoint) {
                setIsLoading(false);
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "Konfigurasi server tidak valid."
                });
                return;
            }

            fetch(`${url}${endpoint}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify(sanitizedData)
            })
                .then(response => {
                    // Check if the response is OK (status 200-299)
                    if (!response.ok) {
                        throw new Error("Failed to send message");
                    }
                    return response.json(); // Parse the response as JSON
                })
                .then(data => {
                    setIsLoading(false);
                    if (data.success) {
                        Swal.fire({
                            icon: "success",
                            title: "Berhasil",
                            text: "Pesan Terkirim"
                        }).then((result) => {
                            if (result.isConfirmed) {
                                window.location.reload();
                            }
                        });
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: "Gagal Mengirim Pesan."
                        });
                    }
                })
                .catch(error => {
                    setIsLoading(false);
                    Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: error.message || "Something went wrong. Please try again later."
                    });
                });
        }
    };

    return (
        <div className="page-wrapper">
            <section className="page-banner">
                <div className="container">
                    <div className="page-banner-title">
                        <h3>{t('menu.kontak')}</h3>
                    </div>
                </div>
            </section>
            <section className="contact-section py-5 bg-light" style={{ backgroundColor: "#f8f9fa" }}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 order-2 order-lg-1 mb-5 mb-lg-0">
                            <div className="contact-info-box shadow-sm p-4 p-lg-5 rounded bg-white h-100" style={{ borderTop: "4px solid #00a651" }}>
                                <h4 className="mb-4" style={{ fontWeight: '600', color: '#333' }}>{t('informasiKontak')}</h4>
                                <div className="d-flex mb-4 align-items-start">
                                    <div className="icon-box bg-light rounded-circle d-flex justify-content-center align-items-center" style={{ width: "50px", height: "50px", minWidth: "50px", color: "#00a651" }}>
                                        <i className="fa-solid fa-map-marker-alt fs-5"></i>
                                    </div>
                                    <div className="ms-3 pt-1">
                                        <h6 className="mb-1" style={{ fontWeight: '600', color: '#333' }}>{t('alamat')}</h6>
                                        <p className="mb-0 text-muted" style={{ fontSize: "14px", lineHeight: "1.6" }} dangerouslySetInnerHTML={{ __html: t('alamatKneks') }}></p>
                                    </div>
                                </div>
                                <div className="d-flex mb-4 align-items-center">
                                    <div className="icon-box bg-light rounded-circle d-flex justify-content-center align-items-center" style={{ width: "50px", height: "50px", minWidth: "50px", color: "#00a651" }}>
                                        <i className="fa-solid fa-envelope fs-5"></i>
                                    </div>
                                    <div className="ms-3">
                                        <h6 className="mb-1" style={{ fontWeight: '600', color: '#333' }}>Email</h6>
                                        <p className="mb-0" style={{ fontSize: "14px" }}>
                                            <a href="mailto:humas@kneks.go.id" className="text-muted text-decoration-none" style={{ transition: "color 0.3s" }}>humas@kneks.go.id</a>
                                        </p>
                                    </div>
                                </div>

                                <div className="mt-4 pt-4 border-top">
                                    <h6 className="mb-3" style={{ fontWeight: '600', color: '#333' }}>{t('lokasiKami')}</h6>
                                    <div className="mb-4 rounded overflow-hidden shadow-sm" style={{ border: "1px solid #eee" }}>
                                        <iframe
                                            width="100%"
                                            height="250px"
                                            title="Google Maps Location KNEKS"
                                            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7933.418301716268!2d106.8388627!3d-6.1696863!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f5cbd72035e3%3A0x78a3dc4ef4719cb8!2sKementerian%20Keuangan%20Republik%20Indonesia!5e0!3m2!1sid!2sid!4v1690270978567!5m2!1sid!2sid"
                                            style={{ border: 0, filter: "contrast(1.05)", display: "block" }}
                                            allowFullScreen=""
                                            loading="lazy"
                                            referrerPolicy="no-referrer-when-downgrade"
                                        ></iframe>
                                    </div>
                                    <h6 className="mb-3" style={{ fontWeight: '600', color: '#333' }}>{t('ikutiKami')}</h6>
                                    <div className="social-links d-flex gap-2">
                                        <a href="https://www.instagram.com/kneks.id/" target="_blank" rel="noreferrer" className="d-flex justify-content-center align-items-center rounded-circle text-white" style={{ width: "40px", height: "40px", backgroundColor: "#00a651", transition: "transform 0.3s" }} onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-3px)"} onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                                            <i className="fa-brands fa-instagram"></i>
                                        </a>
                                        <a href="https://www.youtube.com/channel/UCkoy3PTHaKD5OIh3Jx-cGsg?view_as=subscriber" target="_blank" rel="noreferrer" className="d-flex justify-content-center align-items-center rounded-circle text-white" style={{ width: "40px", height: "40px", backgroundColor: "#00a651", transition: "transform 0.3s" }} onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-3px)"} onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                                            <i className="fa-brands fa-youtube"></i>
                                        </a>
                                        <a href="https://twitter.com/kneks_id" target="_blank" rel="noreferrer" className="d-flex justify-content-center align-items-center rounded-circle text-white" style={{ width: "40px", height: "40px", backgroundColor: "#00a651", transition: "transform 0.3s" }} onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-3px)"} onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                                            <i className="fa-brands fa-x-twitter"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-8 order-1 order-lg-2 mb-5 mb-lg-0">
                            <div className="contact-form-box shadow-sm p-4 p-lg-5 rounded bg-white h-100">
                                <div className="mb-4">
                                    <h3 style={{ fontWeight: '700', color: '#333' }}>{t('kirimPesanTitle')}</h3>
                                    <p className="text-muted">{t('descKirimPesan')}</p>
                                </div>
                                <form className="contact-form contact-form-validated" onSubmit={handleSubmit}>
                                    <div className="row row-gutter-20">
                                        {['nama', 'email', 'phone', 'subjek'].map((field, index) => (
                                            <div key={index} className="col-12 col-md-6 mb-3">
                                                <div className="form-group">
                                                    <label className="form-label text-muted mb-2" style={{ fontSize: "14px", fontWeight: "500" }}>{t(field).charAt(0).toUpperCase() + t(field).slice(1)}</label>
                                                    <input
                                                        type={
                                                            field === "email" ? "email" :
                                                                field === "phone" ? "tel" :
                                                                    "text"
                                                        }
                                                        id={field}
                                                        placeholder={`${t('placeholderPrefix')} ${t(field)}...`}
                                                        name={field}
                                                        value={formValues[field] || ''}
                                                        onChange={handleInputChange}
                                                        className={`form-control form-control-lg ${fieldErrors[field] ? "is-invalid" : ""}`}
                                                        disabled={isLoading}
                                                        autoComplete="off"
                                                        spellCheck="false"
                                                        maxLength={field === "nama" ? 50 : field === "email" ? 100 : field === "phone" ? 15 : 100}
                                                        pattern={field === "phone" ? "[0-9+\\-\\s()]{10,15}" : undefined}
                                                        inputMode={
                                                            field === "phone" ? "tel" :
                                                                field === "email" ? "email" :
                                                                    "text"
                                                        }
                                                        style={{ borderRadius: "8px", border: "1px solid #e0e0e0", padding: "12px 15px", backgroundColor: "#fcfcfc" }}
                                                    />
                                                    {fieldErrors[field] && <div className="invalid-feedback">{fieldErrors[field]}</div>}
                                                </div>
                                            </div>
                                        ))}

                                        <div className="col-12 mb-4">
                                            <div className="form-group">
                                                <label className="form-label text-muted mb-2" style={{ fontSize: "14px", fontWeight: "500" }}>{t('tulisPesan')}</label>
                                                <textarea
                                                    name="inputText"
                                                    placeholder={t('placeholderPesan')}
                                                    className={`form-control ${fieldErrors.inputText ? "is-invalid" : ""}`}
                                                    value={formValues.inputText || ''}
                                                    onChange={handleInputChange}
                                                    disabled={isLoading}
                                                    autoComplete="off"
                                                    spellCheck="false"
                                                    maxLength={1000}
                                                    rows={9}
                                                    style={{ borderRadius: "8px", border: "1px solid #e0e0e0", padding: "15px", backgroundColor: "#fcfcfc" }}
                                                ></textarea>
                                                {fieldErrors.inputText && <div className="invalid-feedback">{fieldErrors.inputText}</div>}
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <button
                                                className="btn btn-primary w-100 text-white"
                                                type="submit"
                                                disabled={isLoading}
                                                style={{ borderRadius: "8px", backgroundColor: "#00a651", border: "none", fontWeight: "600", padding: "14px", transition: "all 0.3s" }}
                                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#008a43"}
                                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "#00a651"}
                                            >
                                                {isLoading ? (
                                                    <>
                                                        <span
                                                            className="spinner-border spinner-border-sm me-2"
                                                            role="status"
                                                            aria-hidden="true"
                                                            style={{
                                                                width: '1rem',
                                                                height: '1rem',
                                                                marginRight: '8px'
                                                            }}
                                                        ></span>
                                                        {t('mengirim')}
                                                    </>
                                                ) : (
                                                    <><i className="fa-solid fa-paper-plane me-2"></i> {t('kirimPesanTitle')}</>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Kontak;
